import {
  ComplaintById,
  ComplaintStatus,
  SupportTypeModel,
} from "@modules/plaintes/plaintes.model.ts";
import { TabPanel, TabView } from "primereact/tabview";
import React from "react";
import VictimInfo from "./detailExternalAgent.tsx/victimInfo.tsx";
import AggressorInfo from "./detailExternalAgent.tsx/aggressorInfo.tsx";
import ReportingComplaint from "./detailExternalAgent.tsx/reportingComplaint.tsx";
import ComplaintType from "./detailExternalAgent.tsx/complaintType.tsx";
import SolutionImplement from "./detailExternalAgent.tsx/solutionImplement.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import {
  editComplaint,
  getAllNatureComplaint,
  getComplaintDetails,
} from "@core/actions/complaintAction.ts";
import Solution from "./detailExternalAgent.tsx/solution.tsx";
import { Button } from "primereact/button";
import { loadingEditComplaint } from "@core/slice/ComplaintSlice.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { useLocation, useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
interface DetailHistoryProps {
  complaint: ComplaintById;
  handleChangeActiveIndex: () => void;
  activeIndex: number;
  id: string | undefined;
  setMessageInfo: (a: any) => void;
  setOpen: (a: boolean) => void;
  setActiveIndex: (a: any) => void;
  status: ComplaintStatus;
  isFocalMocipArchived: boolean;
  setVisibleConfirmDialog: (a: boolean) => void;
  isDateOlderThan7Days: (a: any) => number;
}
const DetailHistoryPending: React.FC<DetailHistoryProps> = ({
  complaint,
  handleChangeActiveIndex,
  activeIndex,
  id,
  setMessageInfo,
  setActiveIndex,
  setOpen,
  status,
  isFocalMocipArchived,
  setVisibleConfirmDialog,
  isDateOlderThan7Days,
}) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(loadingEditComplaint);
  const userConnect = useAppSelector(userConnected);
  const navigate = useNavigate();
  const location = useLocation();
  const detailsUserConnected = useAppSelector(userConnected);

  const [selectedInstruction, setSelectedInstruction] = React.useState<
    SupportTypeModel[]
  >([]);
  const [selectedSend, setSelectedSend] = React.useState<any>(undefined);
  const [textAreaValue, setTextAreaValue] = React.useState<string>("");
  const [selectedStatus, setSelectedStatus] = React.useState<any>("");
  const [solutionDisplay, setSolutionDisplay] = React.useState<boolean>(true);
  const [errors, setErrors] = React.useState({
    instruction: "",
    send: "",
    action: "",
    status: "",
  });

  React.useEffect(() => {
    dispatch(getAllNatureComplaint());
  }, [dispatch]);

  const isInternalAgent =
    detailsUserConnected &&
    detailsUserConnected.profil.accesses[0].internalAgent;

  const isDisabled =
    Boolean(isInternalAgent) &&
    (status === ComplaintStatus.RESOLVED_NEGATIVE ||
      status === ComplaintStatus.RESOLVED_POSITIVE);

  function handlePrevious() {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.get("type") === "external") {
      navigate("/");
    } else {
      navigate("/complaint/list-complaint");
    }
  }

  const showSuccessMessage = () => {
    setMessageInfo({
      severity: "success",
      summary: "Succès",
      detail: "La solution a été enregistrée dans l'historique avec succès.",
    });
    setOpen(true);
  };

  const showErrorMessage = () => {
    setMessageInfo({
      severity: "error",
      summary: "Erreur",
      detail: "Une erreur c'est produite , veuillez réessayer!",
    });
    setOpen(true);
  };

  const handleSave = () => {
    let updatedErrors = { ...errors };

    if (selectedInstruction.length === 0) {
      updatedErrors.instruction = "Veuillez choisir une instruction";
    } else updatedErrors.instruction = "";

    if (selectedSend === undefined) {
      updatedErrors.send = "Veuillez choisir un agent";
    } else updatedErrors.send = "";

    if (textAreaValue === "") {
      updatedErrors.action = "Veuillez remplir l'action entreprise";
    } else updatedErrors.action = "";

    if (selectedStatus === "") {
      updatedErrors.status = "Veuillez choisir une status";
    } else updatedErrors.status = "";

    setErrors(updatedErrors);

    if (
      selectedInstruction.length !== 0 &&
      selectedSend !== undefined &&
      textAreaValue !== "" &&
      selectedStatus !== "" &&
      id
    ) {
      dispatch(
        editComplaint({
          filter: {
            id: id,
            actionTaken: textAreaValue,
            complaintId: +id,
            status: selectedStatus.code,
            supportTypes: selectedInstruction.map((a) => a.id),
            userId: +userConnect!.id,
            profilUuid: selectedSend.id,
          },
          onSuccess: () => {
            showSuccessMessage();
            setSolutionDisplay(false);
            setTimeout(() => {
              setOpen(false);
              dispatch(getComplaintDetails(+id));
              setActiveIndex(1);
            }, 2000);
          },
          onError: () => {
            showErrorMessage();
          },
        })
      );
    }
  };

  const handleCancel = () => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.get("type") === "external") {
      navigate("/");
    } else {
      navigate("/complaint/list-complaint");
    }
  };

  const transferStatus = (status: string) => {
    return (
      <>
        {status === ComplaintStatus.PENDING && (
          <div className="flex items-center border border-solid border-[#fcad12] rounded-3xl p-1.5 w-max">
            <i className="pi pi-spinner p-1 bg-[#fcad12] rounded-full text-white text-[10px]" />
            <span className="ml-2 text-[#fcad12] text-[10px] font-medium">
              En attente
            </span>
          </div>
        )}
        {status === ComplaintStatus.ESCALATED && (
          <div className="flex items-center border border-solid border-[#d8d777] rounded-3xl p-1.5 w-max">
            <i className="pi pi-undo p-1 bg-[#8B4513] rounded-full text-white text-[10px]" />
            <span className="ml-2 text-[#8B4513] text-[10px] font-medium">
              Escaladé
            </span>
          </div>
        )}
        {status === ComplaintStatus.IN_PROGRESS && (
          <div className="flex items-center border border-solid border-[#fffc33] rounded-3xl p-1.5 w-max">
            <i className="pi pi-undo p-1 bg-[#fffc33] rounded-full text-white text-[10px]" />
            <span className="ml-2 text-[#FFC107] text-[10px] font-medium">
              En cours
            </span>
          </div>
        )}
        {status === ComplaintStatus.RESOLVED_POSITIVE && (
          <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
            <i className="pi pi-check p-1 bg-[#4CAF50] rounded-full text-white text-[10px]" />
            <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
              Résolu positif
            </span>
          </div>
        )}
        {status === ComplaintStatus.RESOLVED_NEGATIVE && (
          <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
            <i className="pi pi-check p-1 bg-[#f90e0e] rounded-full text-white text-[10px]" />
            <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
              Résolu négatif
            </span>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="mx-8">
      <TabView activeIndex={activeIndex} onTabChange={handleChangeActiveIndex}>
        <TabPanel header="DETAIL">
          <div className="bg-gray-200 p-1 sm:p-4 rounded-[20px]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-7 p-4">
              <VictimInfo complaint={complaint} />
              <AggressorInfo aggressors={complaint.aggressors} />
              <ReportingComplaint reportingComplaint={complaint} />
              <ComplaintType complaint={complaint} />
            </div>
            {solutionDisplay &&
              (isInternalAgent || !isFocalMocipArchived) &&
              status !== ComplaintStatus.ARCHIVED && (
                <>
                  <div className="p-4">
                    <SolutionImplement
                      selectedInstruction={selectedInstruction}
                      setSelectedInstruction={setSelectedInstruction}
                      selectedSend={selectedSend}
                      setSelectedSend={setSelectedSend}
                      agentName={`${userConnect?.lastName} ${userConnect?.firstName}`}
                      errors={errors}
                      setErrors={setErrors}
                      userConnect={userConnect}
                      isDisabled={isDisabled}
                    />
                  </div>
                  <div className="p-4">
                    <Solution
                      textAreaValue={textAreaValue}
                      setTextAreaValue={setTextAreaValue}
                      agentPartnerName={
                        complaint.complaintUsers[0].user.lastName +
                        " " +
                        complaint.complaintUsers[0].user.firstName
                      }
                      selectedStatus={selectedStatus}
                      setSelectedStatus={setSelectedStatus}
                      date={complaint.complaintUsers[0].createdAt}
                      errors={errors}
                      setErrors={setErrors}
                      isDisabled={isDisabled}
                    />
                  </div>
                </>
              )}
          </div>

          {isDateOlderThan7Days(complaint.createdAt) > 0 &&
            complaint.status === ComplaintStatus.RESOLVED_NEGATIVE && (
              <div className="w-full text-center text-red-400">
                <i>
                  Cette plainte sera <strong>archivable</strong> dans{" "}
                  {isDateOlderThan7Days(complaint.createdAt)}{" "}
                  {isDateOlderThan7Days(complaint.createdAt) > 1
                    ? "jours"
                    : "jour"}
                  .
                </i>
              </div>
            )}
          {solutionDisplay &&
            (isInternalAgent || !isFocalMocipArchived) &&
            status !== ComplaintStatus.ARCHIVED && (
              <div className="flex gap-3 justify-content-end mt-7">
                <div className="flex justify-content-end">
                  <Button
                    label="Annuler"
                    className={classNames("btn btn-primary w-[120px]", {
                      "btn-primary-disabled": isDisabled,
                    })}
                    onClick={handleCancel}
                    disabled={isDisabled}
                  />
                </div>
                <div className="flex gap-3 justify-content-end">
                  <Button
                    className={classNames("btn btn-primary w-[120px]", {
                      "btn-primary-disabled": isDisabled,
                    })}
                    onClick={handleSave}
                    disabled={isDisabled}
                  >
                    {loading === FetchStatusType.LOADING && (
                      <div className="mr-2 w-4 h-4 rounded-full animate-spin border-y-4 border-solid border-white border-t-transparent shadow-md pe-2"></div>
                    )}
                    Enregistrer
                  </Button>
                </div>
              </div>
            )}
          {isFocalMocipArchived && (
            <div className="flex gap-3 justify-content-end mt-7">
              <div className="flex justify-content-end">
                <Button
                  className={classNames("btn bg-[#fcad12] w-[175px]", {
                    "btn-secondary-disabled":
                      isDisabled ||
                      (isDateOlderThan7Days(complaint.createdAt) > 0 &&
                        complaint.status === ComplaintStatus.RESOLVED_NEGATIVE),
                  })}
                  onClick={() => setVisibleConfirmDialog(true)}
                  disabled={
                    isDisabled ||
                    (isDateOlderThan7Days(complaint.createdAt) > 0 &&
                      complaint.status === ComplaintStatus.RESOLVED_NEGATIVE)
                  }
                >
                  {loading === FetchStatusType.LOADING && (
                    <div className="mr-2 w-4 h-4 rounded-full animate-spin border-y-4 border-solid border-white border-t-transparent shadow-md pe-2"></div>
                  )}
                  <i
                    className="fas fa-archive mr-2"
                    style={{ color: "black" }}
                  />
                  Archiver la plainte
                </Button>
              </div>
            </div>
          )}
        </TabPanel>
        <TabPanel header="HISTORIQUE">
          {complaint.complaintUsers.map((e, index) => {
            return (
              <React.Fragment key={e.id}>
                {e.fieldChanged === "TRANSFER" && (
                  <div className="border border-solid border-[#E5E5E5] rounded p-2 mb-3">
                    <span className="text-black text-sm font-semibold">
                      Transféré vers {e.profil.name}
                    </span>
                    <div className="flex items-center mt-1">
                      <div className="text-[#6C757D] flex items-center">
                        <i className="pi pi-calendar text-xs" />
                        <span className="ml-2 text-xs">
                          {new Date(e.createdAt).toISOString().split("T")[0]}
                        </span>
                      </div>
                      <div className="text-[#6C757D] flex items-center ml-3">
                        <i className="pi pi-user text-xs" />
                        <span className="ml-2 text-xs">
                          {e.user.firstName} {e.user.lastName}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="ml-2 text-xs">
                        {e.supportTypes
                          .map((supportType) => supportType.description)
                          .join(", ")}
                      </span>
                    </div>
                    <hr className="mt-3" />
                    <span className="text-xs break-words">{e.actionTaken}</span>
                  </div>
                )}

                {e.fieldChanged === "STATUS" && (
                  <div className="border border-solid border-[#E5E5E5] rounded p-2 mb-3">
                    <span className="text-black text-sm font-semibold">
                      Changement de statut
                    </span>
                    <div className="flex items-center mt-1">
                      <div className="text-[#6C757D] flex items-center">
                        <i className="pi pi-calendar text-xs" />
                        <span className="ml-2 text-xs">
                          {new Date(e.createdAt).toISOString().split("T")[0]}
                        </span>
                      </div>
                      <div className="text-[#6C757D] flex items-center ml-3">
                        <i className="pi pi-user text-xs" />
                        <span className="ml-2 text-xs">
                          {e.user.firstName} {e.user.lastName}
                        </span>
                      </div>
                    </div>
                    <hr className="mt-3" />

                    <div className="flex items-center mt-2.5">
                      {transferStatus(e.oldStatus)}
                      {complaint.complaintUsers.length > 1 &&
                        index !== complaint.complaintUsers.length - 1 && (
                          <i className="pi pi-arrow-right-arrow-left p-1 rounded-full text-[#6C757D] text-base mx-1" />
                        )}

                      {transferStatus(e.newStatus)}
                    </div>
                  </div>
                )}
                {e.fieldChanged === "REF" && (
                  <div className="border border-solid border-[#E5E5E5] rounded p-2 mb-3">
                    <span className="text-black text-sm font-semibold">
                      Changement de réference
                    </span>
                    <div className="flex items-center mt-1">
                      <div className="text-[#6C757D] flex items-center">
                        <i className="pi pi-calendar text-xs" />
                        <span className="ml-2 text-xs">
                          {new Date(e.createdAt).toISOString().split("T")[0]}
                        </span>
                      </div>
                      <div className="text-[#6C757D] flex items-center ml-3">
                        <i className="pi pi-user text-xs" />
                        <span className="ml-2 text-xs">
                          {e.user.firstName} {e.user.lastName}
                        </span>
                      </div>
                    </div>
                    <hr className="mt-3" />

                    <div className="flex items-center mt-2.5">
                      <div className="flex items-center p-1.5 w-max">
                        <span className="ml-2 font-medium">{e.oldRef}</span>
                      </div>

                      {complaint.complaintUsers.length > 1 &&
                        index !== complaint.complaintUsers.length - 1 && (
                          <i className="pi pi-arrow-right-arrow-left p-1 rounded-full text-[#6C757D] text-base mx-1" />
                        )}

                      <div className="flex items-center p-1.5 w-max">
                        <span className="ml-2 font-medium">{e.newRef}</span>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}

          <div className="flex justify-end mt-12">
            <Button
              className="justify-center w-[120px] bg-[#64748B] text-white font-bold py-2 px-4 rounded-md gap-2"
              onClick={handlePrevious}
            >
              Retour
            </Button>
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
};

export default DetailHistoryPending;
